import AccountBalanceRounded from '@mui/icons-material/AccountBalanceRounded';
import CreditCardRounded from '@mui/icons-material/CreditCardRounded';
import MoreHorizRounded from '@mui/icons-material/MoreHorizRounded';
import PaymentsRounded from '@mui/icons-material/PaymentsRounded';
import RequestPageRounded from '@mui/icons-material/RequestPageRounded';
import { MenuItem, Stack, TextField, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { usePaymentMethods } from './hooks';
import type { MethodKind } from './labels';

export const METHOD_ICONS: Record<MethodKind, ReactNode> = {
  CASH: <PaymentsRounded fontSize="small" />,
  BANK_TRANSFER: <AccountBalanceRounded fontSize="small" />,
  CARD: <CreditCardRounded fontSize="small" />,
  CHEQUE: <RequestPageRounded fontSize="small" />,
  OTHER: <MoreHorizRounded fontSize="small" />,
};

/** Select of the shop's active payment methods (with the account each one posts to). */
export function MethodSelect({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  name,
}: {
  value: string;
  onChange: (id: string) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string;
  name?: string;
}) {
  const methods = usePaymentMethods();
  const active = (methods.data?.data ?? []).filter((m) => m.isActive || m.id === value);
  return (
    <TextField
      select
      label="Method"
      name={name}
      value={active.some((m) => m.id === value) ? value : ''}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      fullWidth
      disabled={methods.isLoading}
    >
      {active.map((m) => (
        <MenuItem key={m.id} value={m.id}>
          <Stack direction="row" spacing={1.25} sx={{ alignItems: 'center' }}>
            <Stack sx={{ color: 'text.secondary' }}>{METHOD_ICONS[m.kind]}</Stack>
            <span>{m.name}</span>
            <Typography variant="caption" color="text.secondary">
              {m.accountName}
            </Typography>
          </Stack>
        </MenuItem>
      ))}
    </TextField>
  );
}
